import { SET_TIME } from "../actions/time";
import { utcTimestamp } from "../../utils/time";

export default (state = utcTimestamp(), { type, payload }) => {
  switch (type) {
    case SET_TIME:
      return payload;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/store/reducers/time.js